/**
 * sole purpuse of this file is to import and export styles
 */

import * as styles from './main.scss'

export default styles
